import React, { ReactElement } from "react";

import {
  TextField,
  ListProps,
  Filter,
  FilterProps,
  ReferenceField,
  DateField,
  BooleanField,
} from "react-admin";
import { DEFAULT_PER_PAGE, IdFilter, SearchFilter } from "../../../common";
import {
  CustomizableList,
  CustomizableDatagrid,
  ListRowActions,
} from "../../../components";
import { COMMON_DATE_TIME_FORMAT } from "../../../core";
import { RESOURCE_NAME_PERMISSION_GROUP } from "./constants";

const ListFilters = (props: Omit<FilterProps, "children">) => (
  <Filter {...props}>
    <SearchFilter alwaysOn key="Search" />
    <IdFilter
      source="id"
      label="components.controls.filters.idFilter.label"
      key="id"
    />
  </Filter>
);
const defaultColumns = ["name", "label", "description"];
const PermissionGroupsList = (props: ListProps): ReactElement => {
  return (
    <CustomizableList
      {...props}
      sort={{ field: "name", order: "ASC" }}
      perPage={DEFAULT_PER_PAGE}
      filters={<ListFilters />}
      defaultColumns={defaultColumns}
    >
      <CustomizableDatagrid optimized>
        <TextField source="name" />
        <TextField source="description" />
        <TextField source="label" />
        <TextField source="sortOrder" />
        <ReferenceField
          source="parentId"
          reference={RESOURCE_NAME_PERMISSION_GROUP}
        >
          <TextField source="name" />
        </ReferenceField>
        <TextField source="id" />
        <DateField source="createdAt" options={COMMON_DATE_TIME_FORMAT} />
        <DateField source="updatedAt" options={COMMON_DATE_TIME_FORMAT} />

        <TextField source="version" />
        <BooleanField source="isActive" />

        <ListRowActions />
      </CustomizableDatagrid>
    </CustomizableList>
  );
};

export { PermissionGroupsList };
